export default __webpack_public_path__ + "static/media/logo--lightspeed.31b4856f.png";